import { RequestServerClass } from '../../util/request';
import publishObjectPath from '@/util/configRegistry';

const serverUrl = publishObjectPath.serverUrl;

export class ProfessionServer {
  public rSerivce: any;

  constructor(opt: any, axiosFilterFn?: any) {
    this.rSerivce = new RequestServerClass(opt);
    axiosFilterFn.call(this, this.rSerivce.serverObj);
  }

  // 获取分页所有数据
  public getPageData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spacePost';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 获取所有数据
  public getPageDataAll(opts: object) {
    const url = serverUrl + '/api/spaceManage/spacePost/all';
    return this.rSerivce.serverObj.get(url, {
      params: opts,
    });
  }

  // 新增数据
  public addData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spacePost';
    return this.rSerivce.serverObj.post(url, opts);
  }

  // 删除数据
  public deleteData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spacePost';
    return this.rSerivce.serverObj.delete(url, {
      params: opts,
    });
  }

  // 修改数据
  public editData(opts: object) {
    const url = serverUrl + '/api/spaceManage/spacePost';
    return this.rSerivce.serverObj.put(url, opts);
  }

  // 通过 id 获取单个数据
  public getLineData(id: string) {
    const url = serverUrl + '/api/spaceManage/spacePost/' + id;
    return this.rSerivce.serverObj.get(url);
  }
}
